import { AFFORDABLE_PROGRAMS } from './affordable';

/**
 * Determines if a property is eligible for CAU designation
 * Requirements:
 * - The property must meet one of the following criteria:
 *  - Be part of an affordable housing program.
 *  - Be a mixed property.
 *
 * @param {Object} property - The property object
 * @returns {boolean} - True if eligible for CAU designation
 */
export const isEligibleForUnitDesignation = (property) => {
  const propertyPrograms =
    property?.propertyAffordablePrograms || property?.pap || [];

  const propertyType = property?.propertyType || false;
  const hasEligibleProgram = propertyPrograms.some((pap) => {
    const programName = pap?.masterAffordableProgram?.name;
    return (
      propertyType === 'Mixed' ||
      (Object.values(AFFORDABLE_PROGRAMS).includes(programName) &&
        programName !== AFFORDABLE_PROGRAMS.RD)
    );
  });

  return hasEligibleProgram;
};

/**
 * Formats CAU designation options for dropdown display
 * @param {Array<Object>} designations - Raw designation objects from API
 * @returns {Array<Object>} - Formatted options for select field
 * Example: [{ value: null, text: "None" }, { value: "uuid-1", text: "CAU – Manager" }, ...]
 */
export const formatCAUDesignationOptions = (designations) => {
  const noneOption = { value: null, text: 'None' };
  const formattedDesignations = (designations || []).map((designation) => ({
    value: designation.id,
    text: `${designation.name.split('-').join(' - ')}`,
  }));
  return [noneOption, ...formattedDesignations];
};

/**
 * Gets the display text for a CAU designation
 * @param {Object} unitDesignation - The unitDesignation object with name
 * @returns {string|null} - Formatted display text or null
 * Example: "CAU – Manager"
 */
export const getCAUDesignationDisplayText = (unitDesignation) => {
  if (!unitDesignation?.name) return null;
  return `${unitDesignation.name.split('-').join(' - ')}`;
};
